export default {
  importCSV: {
    template: "テンプレート",
    import: "CSV取り込み",
    title: "商品一覧の取り込み",
    note: "50MB以内／CSVファイルのみアップロードしてください。",
    cancel: "キャンセル",
    submit: "取り込み",
    loading: "CSVファイルの取り込み処理を実行しています。完了までしばらくお待ちください。",
    timeout: "アップロードがタイムアウトしました。しばらく時間をおいて、再度お試しください。",
    networkError: "サーバーへの接続に失敗しました。ネットワーク接続を確認し、再試行してください。",
    serverError: "サーバーでエラーが発生しました。CSVファイルのアップロードを再試行してください。",
    success: "CSVの取り込みが完了しました。",
    result: {
      total: "全{total}件中",
      success: "件のレコードを正常に取り込みしました。",
      error: "件のレコードでエラーが発生しました。",
      report: "エラーログ",
      detail: "にて詳細をご確認ください。",
    },
  },
  detailForm: {
    button: {
      back: "前画面に戻る",
      edit: "編集",
      submit: "保存",
    },
    group: {
      basic: "商品情報",
      media: "商品イメージ",
    },
    field: {
      id: "商品コード",
      name: "商品名",
      maker_name: "メーカー名",
      jan_code: "JANコード",
      price_excluding_tax: "本体価格",
      price_including_tax: "税込価格",
      reward_points: "付与ポイント",
      ranking_order: "ランキング",
      ingredients: "成分表示",
      main_copy: "メインコピー",
      stock_quantity: "在庫",
      categories: "属性",
      tags: "タグ",
      extra: {
        id: "※商品コードは自動発番です。",
        jan_code: "※JANコードは変更できません。",
        price: "※売価情報の取り扱いには十分ご注意下さい。",
        reward_points: "※付与ポイント情報の取り扱いには十分ご注意下さい。",
      },
      placeholder: "{name}を入力してください",
    },
    mediaUpload: {
      note: "※登録できる画像形式は「JPG, PNG, JPEG, WEBP」です。5MB以内の画像を登録してください。登録できる画像は、最大4枚までです。",
      removeAll: "すべて削除",
      modal: {
        deleteConfirm: "このファイルを削除しますか？",
        deleteSuccess: "ファイルを削除しました。",
      },
    },
    confirm: {
      priceChangeAlert: "※売価、付与ポイント等が変更されました。ご確認の上、保存してください。",
    },
  },
  filterForm: {
    title: "検索条件",
    label: {
      maker: "メーカー",
      tag: "タグ",
      jan_code: "JANコード",
    },
    choice: {
      all: "全て",
      none: "タグ未設定の商品",
    },
    placeholder: "{name}を入力してください",
  },
  table: {
    header: {
      display_order: "表示順",
      id: "商品コード",
      jan_code: "JANコード",
      name: "商品名",
      maker: "メーカー",
      price_including_tax: "売価",
      reward_points: "付与ポイント",
      stock_quantity: "在庫",
      tags: "タグ",
      category_name: "属性",
      ranking_order: "ランキング",
      edit: "アクション",
      is_display: "表示/非表示",
    },
    placeholder: {
      order: "選択",
    },
  },
  bulkSelectBar: {
    deselectAll: "選択を削除",
    item: "件選択中",
    addTag: "タグに追加",
  },
  addTagModal: {
    title: "タグの選択",
    cancel: "キャンセル",
    submit: "保存",
    modal: {
      noTag: "追加するタグを選択してください。",
    },
  },
}
